import { ScheduledEventPlaceItemFragment } from "../generated/graphql";

export function ifNot<T>(
  condition: boolean | null | undefined,
  res: T,
): T | undefined {
  if (!condition) return res;
  return;
}

export function ifThenElse<T>(
  condition: boolean | null | undefined,
  res1: T,
  res2: T,
): T {
  if (condition) return res1;
  return res2;
}

export function nub<T>(items: T[], toKey: (t: T) => string | number) {
  const values: Map<string, T> = new Map();
  const res: T[] = [];
  items.forEach((item) => {
    const key = `${toKey(item)}`;
    if (!values.has(key)) {
      res.push(item);
      values.set(key, item);
    }
  });

  return res;
}

export function mapURL(place: ScheduledEventPlaceItemFragment) {
  return (
    "https://www.google.co.jp/maps?q=" +
    encodeURIComponent(
      `${place.address1} ${place.address2} ${place.prefecture.name}`,
    )
  );
}

// we seed https://robohash.org/ images in development
export function imageSizerString(
  imageUrl: string,
  width: number,
  height: number,
) {
  if (!imageUrl) return "";
  return imageUrl.includes("https://robohash.org/")
    ? `${imageUrl}?size=${width}x${height}`
    : `${imageUrl}?width=${width}&height=${height}&force=true`;
}
